import { render, staticRenderFns } from "./ArealDistribution.vue?vue&type=template&id=6904ddc2&scoped=true"
import script from "./ArealDistribution.vue?vue&type=script&lang=js"
export * from "./ArealDistribution.vue?vue&type=script&lang=js"
import style0 from "./ArealDistribution.vue?vue&type=style&index=0&id=6904ddc2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6904ddc2",
  null
  
)

export default component.exports